import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { getPrecisePriceWithCurrency } from 'arbitrip-common/general/utils/Currencies';

import { getBookingTotalToPay } from './SettlePayment/utils';

const SelectionFooterBar = ({ selectedBookings, onPayNow }) => {
	const { t } = useTranslation();

	if (!selectedBookings || selectedBookings.length === 0) {
		return null;
	}

	const totalsByCurrency = selectedBookings.reduce((acc, booking) => {
		const { total_to_pay, currency } = getBookingTotalToPay(booking);

		if (!currency || !Number.isFinite(total_to_pay)) {
			return acc;
		}

		acc[currency] = (acc[currency] || 0) + total_to_pay;
		return acc;
	}, {});

	const currencies = Object.keys(totalsByCurrency);

	return (
		<div className="selection-footer-bar" data-testid="selection-footer-bar">
			<div className="selection-footer-bar__count">
				{t('Bookings.SelectToPay.ReservationsSelected', { count: selectedBookings.length })}
			</div>
			<div className="selection-footer-bar__actions">
				{currencies.length > 0 && (
				<div className="selection-footer-bar__total">
					<span className="selection-footer-bar__total-value">
						{currencies
							.map((currency) => getPrecisePriceWithCurrency(totalsByCurrency[currency], currency))
							.join(' + ')}
					</span>
					<span className="selection-footer-bar__total-label">{t('Bookings.SettlePayment.TotalToPay')}</span>
				</div>
			)}
			<Button
				variant="contained"
				className="selection-footer-bar__pay-now-button"
				onClick={onPayNow}
				disableRipple
				data-testid="selection-footer-bar__pay-now-button"
			>
				{t('PayNow')}
			</Button>
			</div>
		</div>
	);
};

export default SelectionFooterBar;
